import React from 'react';
import { setEntranceUrl, getEntranceUrl } from '@/utils/localStorage';

function useEntryPath() {

  function saveEntryPath() {
    const {
      href,
      pathname,
      search,
      hash
    } = window.location;
    if (href.toLowerCase().indexOf('login') > -1) {
      let entryPath = pathname + search;
      if (hash) {
        entryPath = entryPath + hash;
      }
      console.log('entryPath', entryPath);
      setEntranceUrl(entryPath);
    }
  }

  function getEntryPath() {
    const entry = getEntranceUrl();
    return entry;
  }

  return { saveEntryPath, getEntryPath }
}

export default useEntryPath;